module.exports = __webpack_public_path__ + "static/media/clarity_logo.91fa0a8c.svg";